import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: Routes.DASHBOARD,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/DashboardContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'dashboard', reducer: reducer.default })
    cb(null, module.default)
  }
})
